import hark from 'hark'

export const getDecibel = (stream, self) => {
  // 現在のマイクの音量を取得
  if (!stream || stream.getAudioTracks().length === 0) return

  const harker = hark(stream, { threshold: -75 })

  harker.on('volume_change', (db) => {
    if (db === -Infinity) return
    // componentのdataのdecibelに直接代入
    self.decibel = db
  })

  return () => harker.stop()
}

export const getAudioLevelHeight = (decibel, value) => {
  // 音量のバーの高さを計算
  return { height: ((decibel + 100) * value) + '%' }
}
